import React from "react";
import { styled } from "@material-ui/core/styles";
import CheckIcon from "@material-ui/icons/Check";

const Check = styled(CheckIcon)({
  color: "#007FBD"
});

function groupPlanExcelCell(options, column, gridCell) {
  if (gridCell.value != null) {
    options.value = "Да";
  }
}

function groupPlanCell(config) {
  config.alignment = "center";
  config.cellRender = GroupPlanCell;
}

const GroupPlanCell = (cellData) => {
  return <div>{cellData.text && <Check />}</div>;
}

export {groupPlanCell, groupPlanExcelCell}
